import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scroll(event) {
    const href = event.currentTarget.getAttribute("href")
    if (!href || !href.startsWith("#")) return

    const targetId = href.slice(1)
    const target = document.getElementById(targetId)
    if (!target) return

    event.preventDefault()

    const navRect = this.element.getBoundingClientRect()
    const targetTop = target.getBoundingClientRect().top + window.scrollY

    window.scrollTo({
      top: targetTop - (navRect.top + navRect.height),
      behavior: "smooth"
    })
  }
}
